import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../../../Contexts/LanguageContext';
import './LanguageOption.scss';

const LanguageOption = () => {
  const {  changeLanguage, languagesList } = useLanguage();
  const [showOptions, setShowOptions] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState({
    id: 'us',
    name: 'English',
    flag: '/Assets/images/globe.svg',
  });

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  const selectLanguage = (language) => {
    setSelectedLanguage(language);
    changeLanguage(language.id);
    setShowOptions(false);
  };


  // const languages = [
  //   {
  //     id: 'us',
  //     name: 'English',
  //     flag: require('../../../Assets/images/flag-us.svg').default,
  //   },
  //   {
  //     id: 'it',
  //     name: 'Italian',
  //     flag: require('../../../Assets/images/flag-it.svg').default,
  //   },
  //   {
  //     id: 'de',
  //     name: 'German',
  //     flag: require('../../../Assets/images/flag-de.svg').default,
  //   },
  //   {
  //     id: 'cn',
  //     name: 'Chinese',
  //     flag: require('../../../Assets/images/flag-cn.svg').default,
  //   },
  // ];

  return (
    <>
      <div className="language-dropdown" ref={dropdownRef}>
        <div className="language-button" onClick={toggleOptions}>
          <img
            className="flag-icon"
            src={selectedLanguage.flag}
            alt={`${selectedLanguage.name} Flag`}
          />
          <span id="selectedLanguage">{selectedLanguage.name}</span>
        </div>
        {showOptions && (
          <div className="language-options">
            {languagesList.map((language) => (
              <div
                key={language.id}
                className="language-option"
                onClick={() => selectLanguage(language)}
              >
                <img
                  className="flag-icon"
                  src={language.flag}
                  alt={`${language.name} Flag`}
                />
                {language.name}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default LanguageOption;
